var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckpointHarmony(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8697 13.0616C17.1617 17.7455 15.9209 21.1686 12.0008 21.1686C8.08076 21.1686 6.71236 16.8709 7.1813 13.0616C7.64787 9.27162 10.1216 5.18552 11.9727 2.84546C11.9872 2.82719 12.0142 2.82767 12.0283 2.84624C13.855 5.25608 16.374 8.6287 16.8697 13.0616Z",
    fill: "#C42CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04188 6.04365C2.95899 6.28155 5.34233 6.58885 7.70145 7.46896C6.93686 9.15178 6.38397 11.0917 6.09144 13.2155C5.67225 16.2596 6.24856 18.9327 7.91054 20.3176C6.66142 19.4725 5.50268 18.2344 4.5825 16.9826C2.31762 13.9012 1.19116 9.14331 1.00007 6.08199C0.998676 6.05972 1.01974 6.0409 1.04188 6.04365Z",
    fill: "#C42CE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9581 6.04419C21.041 6.28208 18.6577 6.58939 16.2986 7.46949C17.0631 9.15231 17.616 11.0922 17.9086 13.216C18.271 15.8481 17.8835 18.3025 16.6993 19.8721C17.7135 19.0653 18.6489 18.0287 19.4175 16.9832C21.6824 13.9017 22.8088 9.14384 22.9999 6.08252C23.0013 6.06025 22.9803 6.04144 22.9581 6.04419Z",
    fill: "#C42CE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpointHarmony);
export default __webpack_public_path__ + "static/media/CheckpointHarmony.37b5cd643183407af33b3e7df3570665.svg";
export { ForwardRef as ReactComponent };